import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import moment from 'moment';
import { toWeekStartDate } from '../../../helpers/moment';
import MonthlyReports from './MonthlyReports';

const WeekMonthUpload = ({
  showModal,
  showAdditionalModal,
  activeView,
  toggleView,
  activeWeek,
  activeSite,
  sites,
  activeClient,
  activeDate,
  siteAssociates,
  selectedDate,
}) => {
  const type = localStorage.getItem('type');
  const location = useLocation();

  let startWeek = toWeekStartDate(moment());
  let activeClass = 'btn btn-brand';
  let inactiveClass = 'btn btn-outline-brand';
  return (
    <div className="d-flex align-items-center py-4">
      <div className="btn-group rounded ms-4">
        <MonthlyReports
          activeSite={activeSite}
          sites={sites}
          activeClient={activeClient}
          activeDate={activeDate}
          siteAssociates={siteAssociates}
          location={location}
          selectedDate={selectedDate}
        />
      </div>
    </div>
  );
};

export default WeekMonthUpload;
